import { Box, Typography, IconButton, TextField, Tooltip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useLocations } from '../../../shared/context/locationsContext'
import { useEffect } from 'react'
import { Refresh as RefreshIcon } from '@mui/icons-material'
import { useUtiles } from '../../../shared/context/utilesContext'
import LocationOnIcon from '@mui/icons-material/LocationOn';
export default function SelectLocationComponent({ setSelectLocationParent }) {
    const theme = useTheme()
    const { locations, getLocations, pagination } = useLocations()
    const { locationString, toogleOpenSilder } = useUtiles()
    useEffect(() => {
        getLocations()
    }, [])

    const handleSelectLocationParent = (location) => {
        setSelectLocationParent(location)
        toogleOpenSilder(null, 500, '')
    }

    const handleSearch = (e) => {
        getLocations({ name: e.target.value })
    }

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{  display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                    Se muestran {locations.length} de {pagination.count} ubicaciones en total
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
                <Tooltip title="Refrescar">
                    <IconButton size="small" onClick={() => getLocations()}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box sx={{  display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                   Busca por nombre para encontrar una ubicación
                </Typography>
            </Box>


            <Box sx={{ mt: 2, maxHeight: '70vh', overflow: 'auto' }}>
                {locations.map((location) => (
                    <Box
                        key={location.id}
                        onClick={() => handleSelectLocationParent(location)}
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            p: 1.5,
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                                cursor: 'pointer'
                            }
                        }}
                    >
                        <Box sx={{ mr: 1.5, mt: 0.5 }}>
                            <LocationOnIcon color="primary" fontSize="small" />
                        </Box>
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 'medium', color: theme.palette.text.primary }}>
                                {location.name}
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
                                Código: {location.code || ''}
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
                                Clasificación 1: {location.classification1?.value || ''}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block', color: theme.palette.text.secondary }}>
                                Localización: {locationString(location.parent)}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>




        </Box>
    )
}